module.exports = __webpack_public_path__ + "img/solution-01.50b246cf.jpg";